import React, { Component } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';

import Loading from './components/Loading';
import Error from './components/Error';
import Dashboard from './screen/dashboard';

class App extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }

        if (!firebase.apps.length) {
            //Intialize the default app instance.
            var config = {
                apiKey: "AIzaSyCXEpr1hjO7CipAqDxY8UVEBXYsjJmIjQI",
                authDomain: "dnm-dashboard.firebaseapp.com",
                databaseURL: "https://dnm-dashboard.firebaseio.com",
                projectId: "dnm-dashboard",
                storageBucket: "dnm-dashboard.appspot.com",
                messagingSenderId: "534777789507"
            };
            firebase.initializeApp(config);
            if (firebase.auth().currentUser == null) {
                firebase.auth().signInAnonymously();
            }
        }
        firebase.auth().onAuthStateChanged(this.onAuthStateChanged, this.onError);
    }
    
    onAuthStateChanged = (user) => {
        this.setState({user, loading: false});
    }

    onError = (error) => {
        this.setState({error, loading: false});
    }

    onOpenURL = (url) => {
        if (url && url.startsWith('/')) {
            //TODO: This is a path within the same site. Open in a modal tab.
        }
        else {
            window.open(url, '_blank');
        }
    }

    render() {
        let {user, error, loading} = this.state;
        return (
            <div className="App">
                { loading && 
                    <Loading />
                }
                { error && 
                    <Error 
                        title="Server Error" 
                        message={error} 
                    />
                }
                {user && 
                    <Dashboard 
                        user={user}
                        onOpenURL={ this.onOpenURL }
                    />   
                }
            </div>
        );
    }
}

export default App;
